import { Outlet } from 'react-router-dom';  
import Header from "../Components/Header";  
import Sidebar from "../Components/Sidebar"; 

function Layout() {
  return (
    <main className='App'>
        <Header />
        <Sidebar />
        <Outlet />
    </main>
  )
}

export default Layout
